<template>
    <div class="student-portal-dashboard" :class="{ dark: dark }">
        <Banner :view="ViewMode" :data="dataCourses" :bannerPortal="bannerPortal"></Banner>

        <KeepWatchingSection />
        <Status
            :view="ViewMode"
            :data="dataCourses"
            :hasReady="hasReady"
        ></Status>

        <Content
            :view="ViewMode"
            :data="dataCourses"
            :hasReady="hasReady"
        ></Content>
    </div>
</template>
<script>
    import apiCourses from '@/utils/portal/course.js';
    import { mapState, mapActions } from 'vuex';

    import Banner from '@/components/Student/Dashboard_Unique/Banner/Banner';
    import Content from '@/components/Student/Dashboard_Unique/Content/Content';
    import KeepWatchingSection from '@/components/Student/Dashboard_Unique/Content/KeepWatchingSection.vue';
    import Status from '@/components/Student/Dashboard_Unique/Status/status';

    export default {
        data() {
            return {
                ViewMode: false,
                dataCourses: null,
                hasReady: false,
                bannerPortal: null,
            };
        },
        computed: {
            ...mapState(['token', 'listCoursesPortal', 'dark']),
        },
        methods: {
            ...mapActions(['storeListCouresesPortal']),
            alterarValor(novoValor) {
                this.ViewMode = !this.ViewMode;
            },
            async getDataCourses() {
                try {
                    const response = await apiCourses.getDataCourses(
                        this.token
                    );
                    this.storeListCouresesPortal({
                        listCoursesPortal: response,
                    });
                    this.dataCourses = response;
                    this.hasReady = true;
                } catch (error) {
                    const errorMessage = error.response?.data?.message || 'Erro ao carregar dados dos cursos, por favor tente novamente mais tarde.';
                    toast.error(errorMessage);
                }
            },
            async getBannerPortal() {
                try {
                    const response = await apiCourses.getBannerPortal(this.token);
                    console.log(response);
                    this.bannerPortal = response;
                } catch (error) {
                    toast.error('Erro ao carregar banner do portal.');
                    console.error('Erro ao carregar banner do portal:', error);
                }
            },
        },
        watch: {
            ViewMode(novoValor) {
                this.ViewMode = novoValor;
                console.log('Modo de visualização alterado:', novoValor);
            },
        },
        components: {
            Banner,
            Content,
            KeepWatchingSection,
            Status,
        },
        created() {
            this.getDataCourses();
            // this.getBannerPortal();
        },
    };
</script>
<style scoped>
    .studentPortal {
        min-height: 100vh !important;
    }

    .student-portal-dashboard {
        background-color: #fbfbfc;
    }
    .dark.student-portal-dashboard {
        background-color: #16151a;
    }
</style>
